import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { MANIFESTO } from "../../data/content";
import { Reveal } from "../../lib/motion";
import { Overline, GoldDivider } from "./Ornament";

const stats = [
  { value: "100%", key: S.about.stat1 },
  { value: "50+", key: S.about.stat2 },
  { value: "48hr", key: S.about.stat3 },
];

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="relative bg-ivory grain py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        {/* Story */}
        <div className="max-w-3xl mx-auto text-center">
          <Overline>{t(S.about.overline)}</Overline>
          <h2 className="mt-4 font-serif font-light text-maroon leading-[1.1] tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            {t(S.about.heading)}
          </h2>
          <GoldDivider className="mt-6" />
          <p className="mt-7 text-maroon/75 leading-relaxed text-base sm:text-lg">{t(S.about.p1)}</p>
          <p className="mt-4 text-maroon/70 leading-relaxed text-sm sm:text-base">{t(S.about.p2)}</p>
        </div>

        {/* Numbered manifesto chapters */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.no} delay={i * 0.1}>
              <div className="relative pl-0 md:pl-6 md:border-l border-gold/25">
                <span className="font-serif text-4xl text-gold/50 leading-none">{m.no}</span>
                <h3 className="mt-3 font-cinzel text-sm tracking-wide uppercase text-maroon">{t(m.title)}</h3>
                <p className="mt-2 text-maroon/65 text-sm leading-relaxed">{t(m.text)}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Stats row */}
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-px bg-gold/20 border border-gold/20 rounded-lg overflow-hidden">
          {stats.map((s) => (
            <div key={s.value} className="bg-cream px-8 py-8 text-center">
              <p className="font-serif text-4xl text-maroon">{s.value}</p>
              <p className="mt-2 font-cinzel text-[10px] tracking-luxe uppercase text-gold">{t(s.key)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
